export default "__VITE_ASSET__C_ijoAvl__"